<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="6">
                  <b-form-group id="nome" label-for="nome" label="Nome *">
                    <b-form-input
                      id="nome"
                      v-model="$v.form.nome.$model"
                      :state="validateState('nome')"
                      maxlength="50"
                      autofocus
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group id="cpf" label-for="cpf" label="CPF">
                    <b-form-input
                      id="cpf"
                      v-model="form.cpf"
                      v-mask="['###.###.###-##']"
                      maxlength="14"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group id="rg" label-for="rg" label="RG">
                    <b-form-input id="rg" v-model="form.rg" maxlength="20" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group id="email" label-for="email" label="E-mail">
                    <b-form-input
                      id="email"
                      v-model="$v.form.email.$model"
                      :state="validateState('email')"
                      type="email"
                      maxlength="255"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group
                    id="telefone"
                    label-for="telefone"
                    label="Telefone"
                  >
                    <b-form-input
                      id="telefone"
                      v-model="form.telefone"
                      v-mask="['(##) #### ####', '(##) # #### ####']"
                      maxlength="30"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group id="status" label-for="status" label="Ativo">
                    <span class="switch switch-icon">
                      <label>
                        <input
                          type="checkbox"
                          :value="true"
                          @change="setAtivo"
                          :checked="form.status == true"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="separator separator-dashed my-6"></div>
              <h5 class="font-weight-bold text-dark mb-5">Endereço</h5>

              <b-row>
                <b-col md="3">
                  <b-form-group id="cep" label-for="cep" label="CEP">
                    <b-form-input
                      id="cep"
                      v-model="form.cep"
                      v-mask="['#####-###']"
                      maxlength="9"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <button
                    type="button"
                    class="btn btn-primary font-weight-bold consultar-cep"
                    :disabled="consultandoCep"
                    @click="consultaCep"
                  >
                    <span
                      v-if="consultandoCep"
                      class="spinner spinner-sm spinner-light mr-2"
                    ></span>
                    Consultar CEP
                  </button>
                </b-col>
                <b-col md="5">
                  <b-form-group
                    id="logradouro"
                    label-for="logradouro"
                    label="Logradouro"
                  >
                    <b-form-input
                      id="logradouro"
                      v-model="form.logradouro"
                      maxlength="100"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="numero" label-for="numero" label="Número">
                    <b-form-input
                      id="numero"
                      v-model="form.numero"
                      maxlength="100"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group id="bairro" label-for="bairro" label="Bairro">
                    <b-form-input
                      id="bairro"
                      v-model="form.bairro"
                      maxlength="100"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    id="complemento"
                    label-for="complemento"
                    label="Complemento"
                  >
                    <b-form-input
                      id="complemento"
                      v-model="form.complemento"
                      maxlength="100"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group id="cidade" label-for="cidade" label="Cidade">
                    <VueSelect
                      id="cidade"
                      v-model="form.cidade"
                      label="cidade"
                      :options="cidades"
                      @input="setCidade"
                      @search="onSearchCidade"
                    >
                      <template slot="no-options">
                        Informe o nome da cidade
                      </template>
                      <template slot="option" slot-scope="option">
                        {{ option.cidade + " - " + option.uf }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.cidade + " - " + option.uf }}
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_vendedor_novo"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{
                  name: 'vendedorLista',
                }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import VendedorData, { VendedorDataValidations } from "./VendedorData";
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import loadsh from "lodash";

export default {
  name: "app-vendedor-form",
  components: {
    VueSelect,
  },
  props: {
    url: {
      type: String,
    },
    vendedor: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      cidades: [],
      consultandoCep: false,
    };
  },
  validations: {
    form: VendedorDataValidations,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  watch: {
    vendedor(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.preencherFormulario(newValue);
      }
    },
  },
  methods: {
    setAtivo() {
      this.form.status = this.form.status == true ? false : true;
    },
    preencherFormulario(dados) {
      this.form = new VendedorData(dados || {});
      this.cidades = this.form.cidade ? [this.form.cidade] : [];
    },
    setCidade(cidade) {
      this.form.cidade = cidade || null;
      this.form.id_cidade = cidade ? cidade.id_cidade : null;
    },
    onSearchCidade(search, loading) {
      if (!search.length) {
        return;
      }

      loading(true);
      this.searchCidade(loading, search, this);
    },
    searchCidade: loadsh.debounce(async (loading, search, vm) => {
      vm.cidades = await vm.getCidade(search);
      loading(false);
    }, 350),
    async consultaCep() {
      if (!this.form.cep) {
        this.$toast.warning("Informe um CEP para consultar.");
        return;
      }

      this.consultandoCep = true;

      try {
        const cep = await this.getCep(this.form.cep);

        if (!cep || cep.erro || (Array.isArray(cep) && cep.length === 0)) {
          this.$toast.warning("Confira o CEP informado!");
          return;
        }

        this.form.logradouro = cep.logradouro || "";
        this.form.bairro = cep.bairro || "";
        this.cidades = await this.getCidadeByUF(cep.localidade, cep.uf);

        if (this.cidades.length) {
          this.setCidade(this.cidades[0]);
        }
      } finally {
        this.consultandoCep = false;
      }
    },
    async getDataInit() {
      this.preencherFormulario(this.vendedor);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_vendedor_novo"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        const payload = {
          ...this.form,
          id_cidade: this.form.cidade
            ? this.form.cidade.id_cidade
            : this.form.id_cidade,
        };
        delete payload.cidade;

        await this.$http.post(this.url, payload);

        this.$router.push({ name: "vendedorLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
</script>

<style src="vue-select/dist/vue-select.css"></style>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
.form-user-access {
  max-width: 400px;
  display: flex;
  margin: 30px auto;
  border: 2px solid #dedede;
  border-radius: 8px;
  padding: 1rem;
}
.recursos-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30%;
}
.consultar-cep {
  margin-top: 25px;
  white-space: nowrap;
}
</style>
